import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGoogleCalendar } from '../../hooks/useGoogleCalendar';

export default function CalendarCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loading } = useGoogleCalendar();

  useEffect(() => {
    // Google Calendar uses popup-based OAuth (Google Identity Services),
    // not redirect-based. This callback route exists for legacy compatibility.
    // Just redirect to calendar settings.
    navigate('/settings/calendar');
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-text-secondary">Completing Google Calendar setup...</div>
      </div>
    );
  }

  return null;
}